import React, { useState, useEffect } from 'react';
import Swal from "sweetalert2";
import Select from "react-select";
import LoadingScreen from "../util/LoadingScreen";
import ApiService from "../util/ApiService";
import { Modal, Button } from 'react-bootstrap';
import StatesSelect from "../util/StatesSelect";  // Importando Modal e Button do react-bootstrap

const ModalRemakeDocuments = ({ show, onClose, rejectedDocs, rejectObservation, rejectedData }) => {
    const [currentDoc, setCurrentDoc] = useState(null);
    const [selectedUfDoc, setSelectedUfDoc] = useState(null);
    const [ufs, setUfs] = useState([]);
    const [loadingPage, setLoadingPage] = useState(false); // Carregamento geral para os documentos
    const [loadingAdhere, setLoadingAdhere] = useState(false); // Estado de carregamento para a solicitação de adesão
    const [docNumber, setDocNumber] = useState("");
    const [file, setFile] = useState(null);
    const [remainingDocs, setRemainingDocs] = useState(rejectedDocs);
    const [typeOfPerson, setTypeOfPerson] = useState(null);
    const typeOptions = [
        { value: 1, label: "Física" },
        { value: 2, label: "Jurídica" }
    ];

    useEffect(() => {
        setRemainingDocs(rejectedDocs);

    }, [rejectedDocs]);



    const handleEditDocument = (doc) => {
        if (doc) {
            setCurrentDoc(null); // Limpa o estado para forçar a atualização do modal
            setTimeout(() => { // Força o re-render do modal
                setCurrentDoc(doc);
                setSelectedUfDoc(doc.state ? { value: doc.state, label: doc.state } : null);
                setDocNumber(doc.doc_number || "");
                setFile(null);
            }, 0);
        } else {
            console.warn("Documento inválido selecionado");
        }
    };

    const removeAllBackdrops = () => {
        document.querySelectorAll('.modal-backdrop').forEach(backdrop => {
            backdrop.remove();
        });
    };

    // Função para atualizar os documentos no estado local
    const updateDocsInParent = (updatedRemainingDocs) => {
        setRemainingDocs(updatedRemainingDocs);
    };

    // Função para enviar a solicitação de nova adesão ao backend
    const handleAdhereRequest = async () => {
        setLoadingAdhere(true); // Ativar estado de carregamento
        try {
            const response = await ApiService.send('post', process.env.REACT_APP_URL_API + 'documents/adhere', {
                user_id: rejectedData?.id_logged_in_user,
                consent: true
            }, true);

            if (response.code === 200) {
                Swal.fire({
                    icon: 'success',
                    title: 'Nova solicitação enviada com sucesso!',
                });
                onClose();
            } else {
                Swal.fire({
                    icon: 'error',
                    title: 'Erro ao enviar solicitação',
                    text: response.data.message,
                });
            }
        } catch (error) {
            ApiService.handleApiError(error);
        } finally {
            setLoadingAdhere(false); // Desativar estado de carregamento
        }
    };

    const handleSubmitDocuments = async (event) => {
        event.preventDefault();

        const fileInput = event.target.document_file?.files[0];
        if (!fileInput) {
            Swal.fire({
                icon: 'error',
                title: 'Nenhum arquivo selecionado',
                text: 'Por favor, selecione um arquivo antes de enviar.',
            });
            return;
        }

        setLoadingPage(true); // Ativa o carregamento

        const formData = new FormData();
        formData.append('id', currentDoc ? currentDoc.doc_id : "");
        formData.append('file', fileInput);
        formData.append('doc_number', docNumber);
        formData.append('state', selectedUfDoc ? selectedUfDoc.value : "");
        formData.append('id_type', currentDoc ? currentDoc.id_type : "");
        formData.append('type_of_person', typeOfPerson ? typeOfPerson.value : "");

        try {
            const response = await ApiService.sendArquivo('post', process.env.REACT_APP_URL_API + 'doc/register', formData);

            if (response.code === 200) {
                Swal.fire({
                    icon: 'success',
                    title: 'Documento salvo com sucesso!',
                });

                // modal de envio de doc fechar
                setCurrentDoc(null);

                const updatedRemainingDocs = remainingDocs.filter(doc => doc.id_type !== currentDoc.id_type);
                updateDocsInParent(updatedRemainingDocs); // Atualiza os documentos restantes

                if (updatedRemainingDocs.length === 0) {
                    Swal.fire({
                        icon: 'success',
                        title: 'Todos os documentos foram enviados!',
                        text: 'Agora, o próximo passo será confirmado.',
                    }).then(() => {
                        handleAdhereRequest();  // Chama a função para enviar solicitação de adesão
                    });
                }
            } else {
                Swal.fire({
                    icon: 'error',
                    title: 'Erro ao salvar documento',
                    text: response.data.message,
                });
            }
        } catch (error) {

            ApiService.handleApiError(error);
        } finally {
            setLoadingPage(false); // Finaliza o estado de carregamento
        }
    };

    return (
        <>
            {loadingPage && <LoadingScreen />}
            {loadingAdhere && <LoadingScreen />} {/* Mostra a tela de carregamento durante a adesão */}

            <Modal show={show} onHide={onClose} size="lg" centered>
                <Modal.Header closeButton>
                    <Modal.Title>Documentos Rejeitados</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="form-group">
                        <label>Observação sobre a Rejeição</label>
                        <textarea
                            className="form-control"
                            rows="3"
                            value={rejectObservation}
                            readOnly
                        />
                    </div>
                    <div className="form-group mt-4">
                        <label>Documentos Rejeitados</label>
                        <ul className="list-group">
                            {remainingDocs.length > 0 ? (
                                remainingDocs.map((doc, index) => (
                                    <li key={index} className="list-group-item d-flex justify-content-between align-items-center">
                                        <span>{doc.doc_type_name || `Documento ${index + 1}`}</span>
                                        <button type="button" className="btn btn-primary" size="sm" onClick={() => handleEditDocument(doc)}>
                                            Enviar Documento
                                        </button>
                                    </li>
                                ))
                            ) : (
                                <>
                                    <div className="alert alert-primary" role="alert">Nenhum documento rejeitado
                                        pendente.
                                    </div>
                                    <button type="button" className="btn btn-primary" size="sm"  onClick={() =>handleAdhereRequest()}>
                                        Solicitar novamente
                                    </button>
                                </>
                            )}
                        </ul>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <button type="button" className="btn btn-danger"  onClick={() =>onClose()}>
                        Fechar
                    </button>
                </Modal.Footer>
            </Modal>

            {currentDoc && (
                <Modal show={!!currentDoc} onHide={() => setCurrentDoc(null)} size="lg" centered>
                    <Modal.Header closeButton>
                        <Modal.Title>Cadastro Documento - {currentDoc.doc_type_name}</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <form onSubmit={handleSubmitDocuments}>
                            {currentDoc?.visible_value === 1 && (
                                <div className="form-group">
                                    <label>Número</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        name="doc_number"
                                        value={docNumber}
                                        onChange={(e) => setDocNumber(e.target.value)}
                                    />
                                </div>
                            )}

                            {currentDoc?.visible_state === 1 && (
                                <div className="form-group">
                                    <label>Estado</label>
                                    <StatesSelect value={selectedUfDoc} onChange={setSelectedUfDoc} />
                                </div>
                            )}

                            {currentDoc?.visible_type_of_person === 1 && (
                                <div className="form-group">
                                    <label>Tipo</label>
                                    <Select
                                        value={typeOfPerson}
                                        options={typeOptions}
                                        placeholder="Tipo"
                                        isSearchable
                                        onChange={setTypeOfPerson}
                                        menuPortalTarget={document.body} // Renderiza o menu fora do contêiner pai
                                        styles={{
                                            menuPortal: base => ({
                                                ...base,
                                                zIndex: 9999
                                            }), // Definindo z-index alto
                                            menu: base => ({...base, zIndex: 9999}) // Ajuste de z-index no próprio menu
                                        }}
                                    />
                                </div>
                            )}

                            {currentDoc?.visible_file === 1 && (
                                <div className="form-group">
                                    <label>Comprovante Documento</label>
                                    <input
                                        type="file"
                                        className="form-control"
                                        name="document_file"
                                        onChange={(e) => setFile(e.target.files[0])}
                                    />
                                    <small className="text-secondary">O formato de arquivo recomendado
                                        é <b>PDF</b></small>
                                </div>
                            )}

                            <button type="submit" className="btn btn-primary mt-3">
                                Enviar Documento
                            </button>
                        </form>

                    </Modal.Body>
                </Modal>
            )}
        </>
    );
};

export default ModalRemakeDocuments;
